import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import type { ReactNode } from 'react';

import { Card } from '../Card.js';

dayjs.extend(relativeTime);

type FeedItemProps = {
  label: string;
  occurredAt: Date;
  children: ReactNode;
};

export const FeedItem = ({ label, occurredAt, children }: FeedItemProps) => {
  // SDK response types use Date, while JSON responses deliver ISO timestamp strings.
  const timestamp = new Date(occurredAt);
  return (
    <Card>
      <article className="px-1">
        <div className="mb-4 flex items-center justify-between gap-4">
          <p className="text-xs font-medium tracking-[0.16em] text-text-secondary uppercase">
            {label}
          </p>
          <time className="shrink-0 text-xs text-text-secondary" dateTime={timestamp.toISOString()}>
            {dayjs(timestamp).fromNow()}
          </time>
        </div>
        {children}
      </article>
    </Card>
  );
};
